/**
 * 图片节点「角色」：POST /node_character_design（专用接口，不再走 /volc_chat）
 */

import { fetchNodeCharacterDesignPrompt } from '@/utils/nodeCharacterDesignApi'
import { pickWorkflowStyleRef } from '@/utils/workflowStyleApi'

export function appendWorkflowStyleMetaForCharacterDesigner(volcBase, ws) {
  let base = String(volcBase || '').trim()
  if (!ws || typeof ws !== 'object') return base
  const sn = ws.name != null ? String(ws.name) : ''
  const sp = ws.prompt != null ? String(ws.prompt).trim() : ''
  if (sn || sp) {
    const meta = []
    if (sn) meta.push('StyleName=' + sn)
    if (sp) meta.push('StylePrompt=' + sp)
    base = (base ? base + '\n\n' : '') + '【已选风格】' + meta.join('；')
  }
  return base
}

export function parseCharacterDesignerPaintPrompt(assistantFull) {
  const full = String(assistantFull || '').trim()
  if (!full) throw new Error('角色设计：未返回提示词内容')
  let paintPrompt = full
  const pm = full.match(/【绘图提示词】\s*([\s\S]+)/)
  if (pm && pm[1]) paintPrompt = String(pm[1]).trim()
  paintPrompt = paintPrompt.replace(/^\s+|\s+$/g, '')
  if (!paintPrompt) throw new Error('角色设计：未能解析英文绘图提示词')
  return paintPrompt
}

/**
 * @param {string} volcBase 用户侧描述（可含【已选风格】元信息）
 * @param {{ onDelta?: (chunk: string) => void, signal?: AbortSignal, model?: string }} [opts]
 * @returns {Promise<string>} 英文绘图提示词
 */
export async function streamCharacterDesignerPaintPrompt(volcBase, opts = {}) {
  const base = String(volcBase || '').trim()
  if (!base) {
    throw new Error('请输入角色形象描述（提示词或上游文本节点）')
  }
  const { paintPromptEn, raw } = await fetchNodeCharacterDesignPrompt(base, {
    model: opts && opts.model,
    signal: opts && opts.signal
  })
  if (typeof opts.onDelta === 'function') {
    opts.onDelta(paintPromptEn || raw)
  }
  return parseCharacterDesignerPaintPrompt(paintPromptEn || raw)
}

export function buildCharacterSheetStyleBlock(ws) {
  if (!ws || typeof ws !== 'object') return ''
  const styleName2 = ws.name != null ? String(ws.name) : ''
  const stylePrompt2 = ws.prompt != null ? String(ws.prompt).trim() : ''
  return (
    `STYLE LOCK (must follow):\n` +
    `- Match the style reference image as closely as possible (linework/brush, materials, lighting, color palette, rendering).\n` +
    `- The style reference is ONLY for STYLE TRANSFER, NOT for subject/identity. Do NOT copy the reference subject.\n` +
    `- Selected style name: ${styleName2 || 'custom style'}.\n` +
    (stylePrompt2 ? `- Style keywords (must reflect): ${stylePrompt2}\n` : '') +
    `- Keep the character identity from the text prompt.\n` +
    `- Clean design-sheet layout, white or light gray background.\n`
  )
}

export function buildFinalCharacterSheetPaintPrompt(paintPrompt, ws) {
  const block = buildCharacterSheetStyleBlock(ws)
  const p = String(paintPrompt || '').trim()
  if (!block) return p
  return `${block}\n\n${p}`
}

export function characterSheetStyleRefImages(ws) {
  const styleRef = pickWorkflowStyleRef(ws)
  return styleRef ? [styleRef, styleRef] : []
}

export function resolveNodeImagePaintModelId(seedreamModel) {
  const m = seedreamModel != null ? String(seedreamModel).trim() : ''
  if (m === 'character-designer') return ''
  return m
}

export function nodeNeedsCharacterDesignerLlm(node) {
  if (!node || node.type !== 'image' || !node.data) return false
  const mid = node.data.seedreamModel != null ? String(node.data.seedreamModel).trim() : ''
  return mid === 'character-designer' || !!node.data.uiCharacterDesign
}
